module.exports = __webpack_public_path__ + "media/images/promo/championship/Top_Banner-0ca71b31cb05bc6d480e68418ee5c5f1.jpg";